/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { BankServiceConnection } from '../models/bank-service-connection';


/**
 * API for managing bank service connections.
 */
@Injectable({
  providedIn: 'root',
})
export class BankServiceConnectionsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation listBankServiceConnections
   */
  static readonly ListBankServiceConnectionsPath = '/bank-service-connections';

  /**
   * List all available bank service connections.
   *
   * Lists all available bank service connections that can be used when creating an outgoing payment.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listBankServiceConnections()` instead.
   *
   * This method doesn't expect any request body.
   */
  listBankServiceConnections$Response(params?: {
    context?: HttpContext
  }
): Observable<StrictHttpResponse<Array<BankServiceConnection>>> {

    const rb = new RequestBuilder(this.rootUrl, BankServiceConnectionsService.ListBankServiceConnectionsPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<BankServiceConnection>>;
      })
    );
  }

  /**
   * List all available bank service connections.
   *
   * Lists all available bank service connections that can be used when creating an outgoing payment.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `listBankServiceConnections$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listBankServiceConnections(params?: {
    context?: HttpContext
  }
): Observable<Array<BankServiceConnection>> {

    return this.listBankServiceConnections$Response(params).pipe(
      map((r: StrictHttpResponse<Array<BankServiceConnection>>) => r.body as Array<BankServiceConnection>)
    );
  }

}
